import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
// import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';



const useStyles = makeStyles((theme) => ({
    // root: {
    //     flexGrow: 1,
    //     marginTop: theme.spacing(6),
    // },
    button: {
        fontSize: '14px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '4px 20px',
        letterSpacing: 'normal',
        fontFamily: 'Rubik',
    },
    popTitle: {
        '& h2': {
            fontFamily: 'Rubik',
            fontSize: '18px',
            color: '#444',
        },
        '& div': {
            fontFamily: 'Rubik',
            fontSize: '16px',
            color: '#676767',
            fontWeight: '400',
        },
    },
    popFoot: {
        fontFamily: 'Rubik',
        display: 'initial',
        padding: '0px 24px 15px',
        '& button': {
            marginRight: '16px !important',
            marginTop: '10px !important',
            marginBottom: '10px !important',
        },
    },
}));

export default function CancelDialog({ cancel, handleConfirmation, callOpenServiceClose }) {

    const classes = useStyles();
    const handleClose = () => {
        callOpenServiceClose();
    };
    const handleOk = () => {
        handleConfirmation();
    };

    return (
        <>
            <Dialog
                open={cancel}
                onClose={() => handleClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ fontFamily: 'Rubik' }}
            // disableBackdropClick
            >
                <DialogTitle className={classes.popTitle} id="alert-dialog-title">
                    Please confirm
                    <div>
                        Are you sure you want to Cancel the CRC Review?
                        how ever the added relevance check is saved . Click OK to submit later or click Cancel.
                    </div>
                </DialogTitle>
                {/* <DialogContent>
                    <DialogContentText id="alert-dialog-description" style={{ fontFamily: 'Rubik' }}>
                    Are you sure you want to Cancel the CRC Review? 
                    how ever the added relevance check is saved . Click OK to submit later or click Cancel.
                    </DialogContentText>
                </DialogContent> */}
                <DialogActions className={classes.popFoot}>
                    <Button onClick={handleClose} variant="contained" color="primary" className="txt-capitalize">
                        Cancel
                    </Button>
                    <Button onClick={handleOk} variant="contained" color="primary" className="txt-capitalize">
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
